// should pull this from DB blobs...
var geos = [
  { name: "Bangkok", lat: 13.73114, lon: 100.57529 },
  { name: "Bagan", lat: 21.1717, lon: 94.8585 },
  { name: "Chiang Mai", lat: 18.796143, lon: 98.979263 },
  { name: "Singapore", lat: 1.29027, lon: 103.851959 },
  { name: "Phitsanulok", lat: 16.819044, lon: 100.266008 },
  { name: "Hua Hin", lat: 12.5684, lon: 99.9577 },
  { name: "Songkhla", lat: 7.1988, lon: 100.5951 },
  { name: "Hat Yai", lat: 7.0086, lon: 100.4747 },
  { name: "Krabi", lat: 8.0578, lon: 98.9152 },
  { name: "Phuket", lat: 7.9712, lon: 98.3455 },
  { name: "Koh Yao", lat: 8.0393, lon: 98.589 },
  { name: "Mae Hong Son", lat: 19.3004, lon: 97.9658 },
  { name: "Pai", lat: 19.3585, lon: 98.4422 },
  { name: "Chiang Rai", lat: 19.9102, lon: 99.835 },
  { name: "Lisbon", lat: 38.71709, lon: -9.13926 },
];

var geo = {
  geos() {
    return geos;
  },
  // print distance in meters or km prettily
  prettyDistance(meters, kmMax) {
    if (!kmMax) kmMax = 10; // default max 10km unless otherwise
    if (meters >= kmMax * 1000) return "∞";
    if (meters <= 999) return `${meters}m`;
    var km = meters / 1000;
    if (meters < 10 * 1000) return `${km.toFixed(1)}km`; // 9.2km
    return `${km.toFixed(0)}km`; // 12km
  },

  // same as distanceToUserInMeters
  distance(a, b) {
    // console.log("dist", a, b);
    if (!a || !b) return 999 * 1000; // return a big number or small number if null
    if (!a.lon) a.lon = a.lng;
    if (!b.lon) b.lon = b.lng;
    var km = this.getDistanceFromLatLonInKm(a.lat, a.lon, b.lat, b.lon);
    return Math.round(km * 1000); // round to int meters
  },
  // misnomer, it's just distance between two points, not user necessarily
  distanceToUserInMeters(a, b) {
    // console.log("dist", a, b);
    if (!a || !b) return 999 * 1000; // return a big number or small number if null
    if (!a.lon) a.lon = a.lng;
    if (!b.lon) b.lon = b.lng;
    var km = this.getDistanceFromLatLonInKm(a.lat, a.lon, b.lat, b.lon);
    return Math.round(km * 1000); // round to int meters
  },
  getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  },
  deg2rad(deg) {
    return deg * (Math.PI / 180);
  },
  distKM(a, b) {
    var dist = this.distanceToUserInMeters(a, b);
    return dist / 1000;
  },
  // compute the region for the app setup, e.g. Bangkok, Chiang Mai, Singapore
  // should pull from regions blob in DB, rather than using local var geos array
  getRegion(coords) {
    geos.forEach((g) => {
      g.distance = this.distanceToUserInMeters(g, coords);
    });
    geos.sort((a, b) => {
      return a.distance - b.distance;
    });
    // console.log("geos sorted", geos[0]);
    return geos[0].name;
  },
};

export default geo;
